// Each entry: [spec names in order of preference, axis label]
const DIMENSION_SPECS = [
  [['Product Width (in.)'], 'W'],
  [['Product Depth (in.)'], 'D'],
  [['Product Height (in.)'], 'H']
];

// The measurements fit-compatibility compares against the shopper's space. The fitOptions flow
// filters and displays these, so every value shown is within the shopper's inputs.
export const FIT_DIMENSION_SPEC_NAMES = {
  width: ['Assembled Width (in.)', 'Product Width (in.)'],
  height: ['Assembled Height (in.)', 'Product Height (in.)'],
  depth: ['Depth (Excluding Handles) (in.)', 'Product Depth (in.)']
};

// Width, height, depth: the order shoppers enter their space in
export const FIT_DIMENSION_SPECS = [
  [FIT_DIMENSION_SPEC_NAMES.width, 'W'],
  [FIT_DIMENSION_SPEC_NAMES.height, 'H'],
  [FIT_DIMENSION_SPEC_NAMES.depth, 'D']
];

export const getDimensions = (specificationGroup, dimensionSpecs = DIMENSION_SPECS) => {
  const specifications = (specificationGroup || [])
    .filter((group) => group?.specTitle === 'Dimensions')
    .flatMap((group) => group?.specifications || []);
  const values = dimensionSpecs.map(([specNames, axis]) => {
    const value = specNames
      .map((specName) => specifications.find((spec) => spec?.specName === specName)?.specValue)
      .find(Boolean);
    return value ? `${value.replace(/\s*in\.?$/, '')}"${axis}` : null;
  });
  return values.every(Boolean) ? values.join(' x ') : null;
};
